import axios from "axios";
import Config from "../../config";

/**
 * Encerra a gravação de tela em andamento no widget do visitante. O vídeo já
 * gravado é mantido — o visitante ainda revisa e envia na conversa.
 */
const actionEncerrarGravacao = (chatId, data) =>
    axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/chat/${chatId}/midia/encerrar-gravacao`,
        data,
    });

export default actionEncerrarGravacao;
